/** @jsxImportSource @emotion/react */
'use memo'

import styled from '@emotion/styled'
import colors from '@sportninja/common/constants/appColors'
import type { OrgRegistrationDivisionOption } from '@sportninja/common/features/organization/registration/types'
import { paragraphSmall, paragraphXSmall } from 'src/components/css'
import Price from 'src/components/ts-components/Price'

interface Props {
  /** The player or team option; null when the division doesn't offer it. */
  option: OrgRegistrationDivisionOption | null
  currency: string
}

/** A fee, with its deposit option underneath; a dash when not offered. */
const FeeCell = ({ option, currency }: Props) => {
  'use memo'

  if (!option) {
    return (
      <Wrapper>
        <Value>—</Value>
      </Wrapper>
    )
  }
  return (
    <Wrapper>
      <Value>
        <Price amount={option.fee} currency={currency} compact />
      </Value>
      {option.deposit ? (
        <Deposit>
          <Price amount={option.deposit} currency={currency} compact /> deposit
        </Deposit>
      ) : null}
    </Wrapper>
  )
}

export default FeeCell

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  line-height: 1.3;
  white-space: nowrap;
`

const Value = styled.span`
  ${paragraphSmall}
  color: ${colors.WHITE};
`

const Deposit = styled.span`
  ${paragraphXSmall}
  color: ${colors.NEUTRAL_60};
`
